export default {
  'nav.home': 'Hjem',
  'nav.spreadsheet': 'Spreadsheet',
  'nav.categories': 'Kategorier',
  'nav.guides': 'Guider',
  'nav.reviews': 'Anmeldelser',
  'nav.shipping': 'Forsendelse',
  'nav.safety': 'Sikkerhed',
  'nav.shoppingGuide': 'Købsguide',

  // Page headers
  'page.spreadsheet.title': 'AllChinaBuy Spreadsheet Kategorier',
  'page.spreadsheet.subtitle': 'Gennemse alle kategorier i AllChinaBuy Spreadsheet, og gå direkte til de produkter, du har brug for.',
  'page.guides.title': 'AllChinaBuy Guider og Artikler',
  'page.guides.subtitle': 'Originale, praktiske guider om QC, forsendelse, sikkerhed og købstips.',
  'page.reviews.title': 'AllChinaBuy Anmeldelser og Uafhængig Research',
  'page.reviews.subtitle': 'Ærlig, uafhængig indsigt til at hjælpe dig med at vurdere AllChinaBuy, før du bestiller.',
  'page.safety.title': 'AllChinaBuy Sikkerhedsguide',
  'page.safety.subtitle': 'En praktisk tjekliste til at verificere oplysninger og reducere almindelige købsrisici.',

  'hero.badge': 'Uafhængig ressource · Jævnligt gennemgået',
  'hero.title': 'AllChinaBuy Spreadsheet — Find, sammenlign og shop klogere',
  'hero.subtitle': 'Udforsk organiserede produktfund, kategoriguider, QC-information, forsendelsesressourcer og praktiske købstips ét sted. Uanset om du er ny på AllChinaBuy eller en erfaren køber, hjælper denne ressource dig med at researche produkter, sammenligne muligheder og træffe bedre beslutninger, før du bestiller.',
  'hero.searchPlaceholder': 'Søg efter produkter, kategorier, sælgere eller guider…',
  'hero.ctaPrimary': 'Udforsk spreadsheetet',
  'hero.ctaSecondary': 'Køb nu',
  'hero.trustLine': 'Uafhængig ressource · Nyttige guider · Jævnligt gennemgået',

  'category.title': 'Gennemse efter kategori',
  'category.subtitle': 'Hop direkte til den kategori, du har brug for, på hovedsitet.',
  'category.dropdownLabel': 'Vælg en kategori',
  'category.dropdownPlaceholder': 'Vælg en kategori…',
  'category.viewAll': 'Se alle kategorier',
  'category.note': 'Informationer kan ændre sig. Bekræft produkt- og sælgeroplysninger, før du bestiller.',

  'cat.shoes': 'Sko',
  'cat.hoodies': 'Hoodies / Sweatshirts',
  'cat.tshirts': 'T-shirts',
  'cat.jackets': 'Jakker',
  'cat.pants': 'Bukser / Shorts',
  'cat.headwear': 'Hovedbeklædning',
  'cat.sets': 'Sæt',
  'cat.underwear': 'Undertøj',
  'cat.jersey': 'Trøjer',
  'cat.accessories': 'Tilbehør',
  'cat.bags': 'Tasker',
  'cat.belts': 'Bælter',
  'cat.perfumes': 'Parfumer',
  'cat.other': 'Andre varer',

  'about.title': 'Alt du behøver til AllChinaBuy-research',
  'about.subtitle': 'Et klart og ærligt udgangspunkt for at forstå AllChinaBuy Spreadsheet.',
  'about.paragraph1': 'AllChinaBuy Spreadsheet er en fællesskabsorganiseret samling af produktlinks, kategorier og købsressourcer. Den samler fund inden for sko, tøj, tasker, tilbehør og meget mere, så du kan gennemse det, du har brug for, uden at lede efter spredte links.',
  'about.paragraph2': 'Dette website er en uafhængig informationsressource. Det er ikke det officielle AllChinaBuy-website og er ikke tilknyttet det. Vi forklarer, hvordan spreadsheetet fungerer, hvordan man vurderer produkter, og hvordan man undersøger forsendelse og QC, før man bestiller.',

  'feature.spreadsheet.title': 'AllChinaBuy Spreadsheet',
  'feature.spreadsheet.desc': 'Gennemse organiserede produktfund og kategorieressourcer.',
  'feature.qc.title': 'QC-guider',
  'feature.qc.desc': 'Lær at forstå produktbilleder, kvalitetsdetaljer og størrelser.',
  'feature.shipping.title': 'Forsendelse',
  'feature.shipping.desc': 'Forstå forsendelsesmuligheder, omkostninger, vægt og typiske fejl.',
  'feature.reviews.title': 'Anmeldelser',
  'feature.reviews.desc': 'Læs uafhængig research og praktiske AllChinaBuy-anmeldelser.',
  'feature.safety.title': 'Sikkerhed',
  'feature.safety.desc': 'Lær at verificere oplysninger og mindske typiske købsrisici.',
  'feature.comparisons.title': 'Sammenligninger',
  'feature.comparisons.desc': 'Sammenlign AllChinaBuy med andre populære købsplatforme.',

  'beginner.title': 'Ny på AllChinaBuy?',
  'beginner.desc': 'Start med vores begynderguide for at lære, hvordan spreadsheetet fungerer, hvordan du vurderer produkter, forstår QC-billeder og undersøger forsendelse, før du bestiller.',
  'beginner.cta': 'Læs begynderguiden',

  'research.title': 'Undersøg før du køber',
  'research.desc': 'Produktlinks, priser, sælgere og forsendelsesforhold kan ændre sig. Brug dette website som researchressource og bekræft aktuelle oplysninger, før du køber.',
  'research.cta': 'Læs sikkerhedsguiden',

  'guides.title': 'Seneste guider og artikler',
  'guides.subtitle': 'Originale, praktiske guider til at researche klogere.',
  'guides.readMore': 'Læs artikel',
  'guides.article1.title': 'Sådan bruger du AllChinaBuy Spreadsheet: komplet begynderguide',
  'guides.article1.desc': 'Lær, hvad AllChinaBuy Spreadsheet er, hvordan det er organiseret, og hvordan du gennemser kategorier og verificerer produkter, før du bestiller.',
  'guides.article1.meta': 'En begyndervenlig guide til AllChinaBuy Spreadsheet om, hvordan det virker, kategorienavigation, produktresearch og sikkerhedstips.',

  'faq.title': 'Ofte stillede spørgsmål',
  'faq.subtitle': 'Hurtige svar på almindelige spørgsmål om AllChinaBuy Spreadsheet.',
  'faq.q1': 'Er dette det officielle AllChinaBuy-website?',
  'faq.a1': 'Nej. Dette er en uafhængig informationsressource om AllChinaBuy Spreadsheet. Vi er ikke tilknyttet AllChinaBuy.',
  'faq.q2': 'Hvad er AllChinaBuy Spreadsheet?',
  'faq.a2': 'Det er en fællesskabsorganiseret samling af produktlinks og kategorier. Den hjælper købere med at finde sko, tøj, tasker og tilbehør ét sted.',
  'faq.q3': 'Ændrer priser og links sig?',
  'faq.a3': 'Ja. Produktlinks, priser, sælgere og forsendelsesforhold kan ændre sig når som helst. Bekræft altid aktuelle oplysninger på produktsiden, før du køber.',
  'faq.q4': 'Hvor fører kategoriknapperne hen?',
  'faq.a4': 'Kategoriknapperne og rullemenuen linker til hovedsitet, så du kan gennemse den tilsvarende produktkategori der.',

  'final.title': 'Klar til at udforske AllChinaBuy Spreadsheet?',
  'final.desc': 'Gennemse de nyeste ressourcer, sammenlign kategorier og fortsæt til hovedsitet, når du er klar.',
  'final.cta': 'Udforsk AllChinaBuy-ressourcer',

  'footer.tagline': 'En uafhængig informationsressource om AllChinaBuy Spreadsheet.',
  'footer.disclaimer': 'Dette website er en uafhængig informationsressource og er ikke det officielle AllChinaBuy-website. Produkttilgængelighed, priser, links, sælgere, forsendelsesmuligheder og kampagnetilbud kan ændre sig. Bekræft altid aktuelle oplysninger, før du køber.',
  'footer.resources': 'Ressourcer',
  'footer.categories': 'Kategorier',
  'footer.legal': 'Juridisk',
  'footer.home': 'Hjem',
  'footer.privacy': 'Privatliv',
  'footer.terms': 'Vilkår',
  'footer.disclaimerLink': 'Ansvarsfraskrivelse',
  'footer.rights': 'Alle rettigheder forbeholdes.',

  'lang.en': 'English',
  'lang.fr': 'Français',
  'lang.da': 'Dansk',
  'lang.de': 'Deutsch',

  'article.backHome': 'Tilbage til forsiden',
  'article.breadcrumbHome': 'Hjem',
  'article.breadcrumbGuides': 'Guider',
  'article.updated': 'Sidst opdateret',
  'article.readingTime': 'min læsning',
  'article.keyTakeaways': 'Nøglepunkter',
  'article.notFound': 'Artikel ikke fundet',
};